import React, { useState } from "react";
import getSvgImgSrc from "../../core/utils/getSvgImgSrc";
import ConfirmDelete from "core/ui/confirm-delete";

function ListSvgIcons(props) {
  const { iconList, deleteIcon, editSvgIcon } = props;
  const [showModalDelete, setShowModalDelete] = useState(false);
  const [confirmDeleteText, setConfirmDeleteText] = useState(
    "Delete System Icon?"
  );
  const [iconToDelete, setIconToDelete] = useState(null);

  const onDeleteIconConfirmed = () => {
    deleteIcon(iconToDelete);
    setShowModalDelete(false);
  };

  const onDeleteIconConfirmation = (i) => {
    setIconToDelete(i);
    setConfirmDeleteText(`Delete System Icon "${i.name}"?`);
    setShowModalDelete(true);
  };

  if (iconList === undefined || iconList.length === 0) {
    return (
      <div className="m-3">No Icons to Display</div>
    );
  }

  return (
    <>
      <ul className="icon-list-ul">
        {iconList.map(function (svgIcon, i) {
          return (
            <li key={svgIcon.id}>
              <div>
                Icon:{" "}
                <img height="25" width="25" src={getSvgImgSrc(svgIcon.svg)} alt="icon" />
                <span className="spacer"></span>
                Name: <strong>{svgIcon.name}</strong>
              </div>
              <div className="list-btn-section">
                <button disabled={svgIcon.in_use}
                  title={svgIcon.in_use ? "Icon in use" : ""}
                  onClick={() => onDeleteIconConfirmation(svgIcon)}
                >
                  delete
                </button>
                <button key={i} onClick={() => editSvgIcon(svgIcon)}>
                  edit
                </button>
              </div>
            </li>
          );
        })}
      </ul>
      <ConfirmDelete
        show={showModalDelete}
        label={confirmDeleteText}
        proceed={onDeleteIconConfirmed}
        cancel={() => {setShowModalDelete(false)}}
      />
    </>
  );
}

export default ListSvgIcons;
